import _jsx from "@babel/runtime/helpers/jsx";
var _p;
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { deprecate } from 'react-is-deprecated';
import { List, Section } from 'reaxl';

/**
 *  Formats Next Steps CTAs section in email confirmation modal
 */
function EmailFormNextSteps(_ref) {
  let {
    callsToAction = [],
    timeSavingCTAs = [] // deprecated
  } = _ref;
  // Handle deprecated prop
  if (!callsToAction.length && timeSavingCTAs.length) {
    callsToAction = timeSavingCTAs;
  }
  if (!callsToAction.length) return null;
  const renderItem = function (_temp) {
    let {
      render
    } = _temp === void 0 ? {} : _temp;
    return render;
  };
  return /*#__PURE__*/_jsx(Section, {
    alignment: "left",
    subheading: "Reduce wait time at the dealership",
    uiContext: "section-4"
  }, void 0, _p || (_p = /*#__PURE__*/_jsx("p", {}, void 0, "By completing these steps now, you could save more time during your visit.")), /*#__PURE__*/_jsx(List, {
    className: "list-unstyled margin-vertical-2",
    expanded: true,
    items: callsToAction,
    render: renderItem
  }));
}
export default /*#__PURE__*/memo(EmailFormNextSteps);